export const FEED_EMPTY = "FEED_EMPTY"; //没有feed的状态
export const NEED_LOGIN = "NEED_LOGIN"; //游客模式 需要登陆
export const TIME_LIMIT = "TIME_LIMIT"; //普通的限时
export const FEED_COIN = "FEED_COIN"; //specail feed coin
export const FEED_VIP = "FEED_VIP"; //feed vip
// export const PUNISHED = "PUNISHED";
// export const PROHIBIT = "PROHIBIT";
export const FEED_NORMAL = "FEED_NORMAL"; //普通feed
export const BANNED = "BANNED"; //被gx的服务器banned
export const NORMAL = "NORMAL"; //正常的状态
export const LOGIN_REQUIRED = "LOGIN_REQUIRED"; //需要用户再次登录
export const COLDING = "COLDING"; //gx colding
export const WARNING = "WARNING"; //gx warning
export const COMPLETE_PROFILE = "COMPLETE_PROFILE"; //需要上传头像或者post
export const FEED_CASINO_SLOTS = "FEED_CASINO_SLOTS"; //casino Slots 老虎机
export const FEED_CASINO_SIC = "FEED_CASINO_SIC"; //筛子
export const FEED_CASINO_SPIN = "FEED_CASINO_SPIN"; //转盘
export const FEED_AD = "FEED_AD"; //广告
export const FEED_LUCKY_COIN = "FEED_LUCKY_COIN"; //lucky coins
export const EARN_FEED_SPACING_REST = "EARN_FEED_SPACING_REST"; //earn coins
export const FEED_SUPER_PAY = "FEED_SUPER_PAY"; //super pay
export const FEED_BACK_UP = "FEED_BACK_UP"; //back up
